export default __webpack_public_path__ + "static/media/UFT.67c47531.png";